import { cssColorValue, cssSpacing, overlay, overlayBoxShadow, semanticColors } from "../../styles/index.mjs";
import { TypeList as ListComponent } from "../TypeList/index.mjs";
import styled, { css } from "../../styled-components.mjs";
/* Show up to 5.5 items, then resort to scrolling the rest.
 * We show a "half" item so that it is obvious to the user that there is more below the fold.
 * Small: 32px (item height) * 5.5 + 4px (padding height) = 180px
 * Medium: 48px (item height) * 5.5 + 4px (padding height) = 268px
 */
var focusStyles = function focusStyles($isUsingKeyboard) {
  return css(["outline:none;box-shadow:", ";"], "".concat(overlayBoxShadow, ", 0 0 0 ").concat($isUsingKeyboard ? "3px ".concat(cssColorValue(semanticColors.essentialBase)) : "1.5px ".concat(cssColorValue(semanticColors.decorativeSubdued))));
};
export var List = styled(ListComponent).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "List",
  componentId: "sc-1sxdnaw-0"
})(["", ";display:block;pointer-events:all;inline-size:100%;padding:", ";max-block-size:", ";overflow:auto;&:focus{", ";}", ";"], overlay({
  maxWidth: 'none'
}), cssSpacing('tighter-4', '4px'), function (props) {
  return props.$size === 'small' ? '180px' : '268px';
}, function (props) {
  return !props.$useBrowserDefaultFocusStyle && focusStyles(props.$isUsingKeyboard);
}, function (props) {
  return props.$isFocus && !props.$useBrowserDefaultFocusStyle && focusStyles(props.$isUsingKeyboard);
});